import { actionTypes } from "./actions";

export const initialState = {
  fnStrList: []
};

// ===========================|| COMMON REDUCER ||=========================== //

const fnStrReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FNSTR_GET_REQUEST:
      return {
        ...state,
        isfnStrLoading: true,
      };
    case actionTypes.FNSTR_GET_RECEIVE:
      return {
        ...state,
        fnStrList: action.payload.map((dt, index) => ({ ...dt, id: index })),
        isfnStrLoading: false,
      };
    case actionTypes.FNSTR_GET_FAIL:
      return {
        ...state,
        isfnStrLoading: false,
        isfnStrFail: false,
      };
    default:
      return state;
  }
};

export default fnStrReducer;
